import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';

@Component({
  selector: 'app-buffer',
  templateUrl: './buffer.component.html',
  styleUrls: ['./buffer.component.css']
})
export class BufferComponent implements OnInit {

  constructor( private activatedroute:ActivatedRoute, private router : Router, private assessmentmanger:AssessmentmanagerService) { }



  ngOnInit(): void {
    let assessmentID = this.activatedroute.snapshot.queryParams.aid;
    let classID = this.activatedroute.snapshot.queryParams.classid;
    let batchID = this.activatedroute.snapshot.queryParams.batchid;
    let target= this.activatedroute.snapshot.queryParams.target;


    if(target == this.assessmentmanger.bufferRoute.Details )
    this.router.navigate(['/user/assessmentdetails'], {queryParams:{classid:classID,batchid: batchID,aid:assessmentID}});

    else if(target == this.assessmentmanger.bufferRoute.AddQuestion )
    this.router.navigate(['/user/addquestion'], {queryParams:{classid:classID,batchid: batchID,aid:assessmentID}});

    else if(target == this.assessmentmanger.bufferRoute.NewAssessment )
    this.router.navigate(['/assessments/new'], {queryParams:{classid:classID,batchID: batchID,activity:this.assessmentmanger.activityType.Create}});

    else if(target == this.assessmentmanger.bufferRoute.AssessmentConsole )
    this.router.navigate(['/assessments/'], {queryParams:{classid:classID,batchid: batchID,}});

    else if(target == this.assessmentmanger.bufferRoute.EditAssessment )
    this.router.navigate(['/assessments/edit'], {queryParams:{classid:classID,aid:assessmentID, activity:this.assessmentmanger.activityType.Edit }});
  }

}
